<template>
	<div class="achieve">
		<!-- 导航 -->
		<headerTemplate title="成果展示"></headerTemplate>
		<van-tabs v-model="active">
			<van-tab title="模拟店铺">
				<!-- 模拟商城 -->
				<div class="achieve-mall">
					<div class="show-wapper" v-if="!editSta">
						<van-button @click="changeEditSta" plain size="mini" icon="edit" type="info">编辑</van-button>
						<a :href="showObj.alog_store_url">
							<span>进入店铺</span>
						</a>
					</div>
					<div class="edit-return" v-if="editSta">
						<van-button @click="changeEditSta" plain size="mini" icon="eye-o" type="info">预览</van-button>
						<van-button type="info" size="mini" @click="saveAchieve">保存编辑</van-button>
					</div>
					<div class="mall-content">
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺用户：" :value="showObj.alog_member_name" />
							<van-field v-if="editSta" v-model="showObj.alog_member_name" label="店铺用户名：" disabled
								placeholder="请输入店铺用户名" />
						</div>
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺名称：" :value="showObj.alog_store_name" />
							<van-field v-if="editSta" v-model="showObj.alog_store_name" label="店铺名称：" disabled
								placeholder="请输入店铺名称" />
						</div>
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺地址：" :value="showObj.alog_store_url" />
							<van-field v-if="editSta" v-model="showObj.alog_store_url" label="店铺地址：" disabled
								placeholder="请输入店铺地址" />
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">网店装修：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="alog_dec_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.alog_dec_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">所有宝贝：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="alog_goods_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.alog_goods_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">商品详情：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="alog_desc_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.alog_desc_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">促销活动：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="alog_pro_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.alog_pro_img" />
							</div>
						</div>
					</div>
				</div>
			</van-tab>
			<van-tab title="第三方平台">
				<!-- 第三方 -->
				<div class="achieve-mall">
					<div class="show-wapper" v-if="!editSta">
						<van-button @click="changeEditSta" plain size="mini" icon="edit" type="info">编辑</van-button>
						<a :href="showObj.alog_store_url">
							<span>进入店铺</span>
						</a>
					</div>
					<div class="edit-return" v-if="editSta">
						<van-button @click="changeEditSta" plain size="mini" icon="eye-o" type="info">预览</van-button>
						<van-button type="info" size="mini" @click="saveAchieve">保存编辑</van-button>
					</div>
					<div class="mall-content">
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺用户：" :value="showObj.seller_name" />
							<van-field v-if="editSta" v-model="addObj.sellerNameThird" label="店铺用户名："
								placeholder="请输入店铺用户名" />
						</div>
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺名称：" :value="showObj.store_name" />
							<van-field v-if="editSta" v-model="addObj.storeNameThird" label="店铺名称："
								placeholder="请输入店铺名称" />
						</div>
						<div class="mall-content-item">
							<van-cell v-if="!editSta" title="店铺地址：" :value="showObj.store_url" />
							<van-field v-if="editSta" v-model="addObj.storeUrlThird" label="店铺地址："
								placeholder="请输入店铺地址" />
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">网店装修：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="real_dec_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.real_dec_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">所有宝贝：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="real_goods_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.real_goods_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">商品详情：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="real_desc_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.real_desc_img" />
							</div>
						</div>
						<div class="mall-pic-item">
							<span style="margin-right: 20px;">促销活动：</span>
							<div>
								<imageUploader v-if="editSta" :obj="showObj" objKey="real_pro_img"></imageUploader>
								<van-image v-if="!editSta" class="img-show" :src="showObj.real_pro_img" />
							</div>
						</div>
					</div>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import { getAchieve, addAchieve, uploadAchieveImg } from '../../../api/student'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	import imageUploader from '@/components/imageUploader/imageUploader'
	export default {
		name: 'Home',
		components: {
			headerTemplate, imageUploader
		},
		props: [],
		data() {
			return {
				// tab的显示页
				active: 0,
				// 是否为编辑状态
				editSta: false,
				// ADD添加传入参数
				addObj: {
					sellerNameThird: '',
					storeNameThird: '',
					storeUrlThird: '',
					realDecImg: '',
					realGoodsImg: '',
					realDescImg: '',
					realProImg: '',
					alogDecImg: '',
					alogGoodsImg: '',
					alogDescImg: '',
					alogProImg: ''
				},
				showObj: {}
			}
		},
		created() {
			getAchieve().then(res => {
				console.log(res)
				this.showObj = res.result
			}).catch(error => {
				// this.$router.push('Home')
			})
		},
		methods: {
			// 切换编辑状态
			changeEditSta() {
				this.editSta = !this.editSta
			},
			// 添加
			saveAchieve() {
				let objData = {
					'seller_name': this.addObj.sellerNameThird,
					'store_name': this.addObj.storeNameThird,
					'store_url': this.addObj.storeUrlThird,
					'real_dec_img': this.addObj.realDecImg,
					'real_goods_img': this.addObj.realGoodsImg,
					'real_desc_img': this.addObj.realDescImg,
					'real_pro_img': this.addObj.realProImg,
					'alog_dec_img': this.addObj.alogDecImg,
					'alog_goods_img': this.addObj.alogGoodsImg,
					'alog_desc_img': this.addObj.alogDescImg,
					'alog_pro_img': this.addObj.alogProImg
				}
				addAchieve(objData).then(res => {
					if (res.code == 10000) {
						this.$toast(res.message)
					} else {
						this.$toast(res.message || res.result)
					}
				}).catch(error => {
					console.log(error)
					this.$toast('erro')
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.achieve {
		font-size: 14px !important;

		.achieve-title {
			display: flex;
			align-items: center;
			color: white;
			background-color: #e93b3d;

			.title {
				padding: 10px;
				font-size: 14px;
			}
		}

		.achieve-nav {
			box-shadow: 0 0 5px #bbb7b7;
			margin: 5px 10px 15px 10px;
			padding: 10px;
			background-color: white;
		}

		.achieve-mall {
			box-shadow: 0 0 5px #bbb7b7;
			margin: 5px 10px;
			background-color: white;

			.edit-return,
			.show-wapper {
				padding: 10px 15px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #E0E0E0;
			}

			.mall-title {
				border-bottom: 1px solid #eae5e5;
				display: flex;
				justify-content: space-between;
				padding: 10px;
			}

			.mall-content {
				.mall-content-item {
					margin: 10px 0;
				}

				.mall-pic-item {
					margin: 10px 0;
					padding: 0 15px;
					display: flex;

				}


				.mall-pic-item:last-child {
					padding-bottom: 10px;
				}
			}
		}
	}

	.mall-pic-item {
		&>span {
			width: 100px;
			min-width: 100px;
		}
	}

	.img-show {
		width: auto;
		max-width: 200px;
	}
</style>